import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { isLoggedIn, isExpired } from '../../utils/auth-util';
import AuthorizationService from '../../service/AuthorizationService';
import CmsAPI from '../../../common/apis/CmsAPI';

function ProtectedPage(props) {
  const { children } = props;

  const [isAuth, setIsAuth] = useState(false);
  const [expired, setExpired] = useState(true);
  const [loading, setIsLoading] = useState(true);
  const [lastSeen, setLastSeen] = useState(null);

  useEffect(() => {
    const checkUser = async () => {
      const isUserLoggedIn = await isLoggedIn();
      setIsAuth(isUserLoggedIn);
      setExpired(isExpired());
      setIsLoading(false);
    };
    if (!isAuth || expired) {
      checkUser();
    } else {
      setIsLoading(false);
    }
  }, []);

  if ((!isAuth || expired) && !loading) {
    // If user is not logged in or session has expired, log them out, then redirect them to the login page
    AuthorizationService.logOut();
    return <Redirect to="/login" />; // dont need see this
  } else if (loading) {
    return <div></div>;
  } else if (isAuth && !loading) {
    const user = JSON.parse(localStorage.getItem('userDetails'));
    if (!window.CRISP_TOKEN_ID && user) {
      window.CRISP_TOKEN_ID = user.username;
      $crisp.push(['do', 'session:reset']);
      $crisp.push(['do', 'chat:hide']);
      $crisp.push(['do', 'chat:close']);
      const callback = () => {
        $crisp.push(['do', 'chat:hide']);
      };
      $crisp.push(['on', 'chat:closed', callback]);
    }
    // Log last seen
    if (lastSeen === null) {
      // We haven't logged last seen yet this session,
      // so do that now by pinging updateUser endpoint
      const userLanguage = window.navigator.userLanguage || window.navigator.language;
      const language = userLanguage ? userLanguage.slice(0, 2) : 'en';
      CmsAPI.updateUser({ language });

      setLastSeen(true);
    }

    return children;
  }
}

export default ProtectedPage;
